const ArrowRightIcon = ({ stroke = "#475467" }) => {
      return (
            <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="none"
                  viewBox="0 0 9 16"
            >
                  <path
                        stroke={stroke}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit="10"
                        strokeWidth="1.5"
                        d="M1.425 14.6l5.433-5.433a1.655 1.655 0 000-2.334L1.425 1.4"
                  ></path>
            </svg>
      );
};

export default ArrowRightIcon;
